import { useContext } from 'react'
import { OverlayContext } from '../providers'

export const useOverlay = () => {
  return useContext(OverlayContext)
}
